import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { UnsubscribeMessageModalComponent } from './unsubscribe-message-modal';

export const UnsubscribeMessageModalModule: string = ng
    .module('archiSmall.userSettings.unsubscribeMessageModalModule', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('unsubscribeMessageModalComponent', UnsubscribeMessageModalComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/usersettings/unsubscribe-message-modal/unsubscribe-message-modal.module.ts